/**
 * ISRDebugPanel 动态导入辅助函数
 *
 * ✅ 生产环境（NEXT_PUBLIC_SHOW_ISR_DEBUG 未设置）：完全不打包组件，体积增加 0KB
 * ✅ 测试/本地环境（NEXT_PUBLIC_SHOW_ISR_DEBUG=true）：按需加载组件
 *
 * 使用方式：
 * import { DynamicISRDebugPanel } from '@/components/ISRDebugPanel/dynamic';
 *
 * <DynamicISRDebugPanel
 *   generatedAt={props.isrGeneratedAt}
 *   revalidateIn={props.isrRevalidateIn}
 *   pageName="页面名称"
 *   additionalInfo={{ 语言: props.locale }}
 * />
 */

import dynamic from 'next/dynamic';
import React from 'react';
import type { ISRDebugPanelProps } from './index';

// ⭐ 条件动态导入：只在开发/测试环境加载组件
export const DynamicISRDebugPanel =
  process.env.NEXT_PUBLIC_SHOW_ISR_DEBUG === 'true'
    ? dynamic(() => import('./index').then((mod) => mod.ISRDebugPanel), {
        ssr: false, // 客户端渲染即可
      })
    : ((() => null) as React.FC<ISRDebugPanelProps>); // ✅ 生产环境返回空组件（完全不打包）

// 类型导出（保持类型安全）
export type { ISRDebugPanelProps } from './index';
